"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orangePalette = void 0;
var tempusOrange = '#FB7E34';
var orangePalette = {
  // TODO Possibly deprecating this color in v3, talk with Sarah W.
  orangeDark: '#E25F12',
  orange: tempusOrange,
  tempusOrange: tempusOrange,
  orangeLight: '#FCBE99',
  orangeLightest: '#FEEBE0'
};
exports.orangePalette = orangePalette;